import {
  Logger
} from "twilio-video";

export function useLogger() {
  const logger = Logger.getLogger("twilio-video");
  logger.setLevel(process.env.REACT_APP_TWILIO_LOGLEVEL as any || "debug");
}